<template>
  <v-list-tile
    avatar
    ripple
    :href="followUrl"
    class="list-account"
  >
    <div class="v-list__tile__avatar" v-if="logo">
      <avatar-logo :src="logo" :alt="provider.name"/>
    </div>
    <v-list-tile-avatar v-else>
      <v-icon class="grey lighten-1 white--text">domain</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title :title="provider.name">{{ provider.name }}</v-list-tile-title>
      <v-list-tile-sub-title v-if="label" :title="label">{{ label }}</v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
  import siteUrls from '@/helpers/site_urls'
  import { logoFor } from '@/helpers/providers'
  import AvatarLogo from '@/components/common/AvatarLogo'

  export default {
    data () {
      return {}
    },
    props: ['folder', 'editMode'],
    computed: {
      provider () {
        return this.folder.provider
      },
      followUrl () {
        return `${siteUrls.secureSite}/follows/${this.folder.uuid}`
      },
      hasProvider () {
        return !!this.provider
      },
      logo () {
        return this.hasProvider && logoFor(this.provider, {size: 'small'})
      },
      serviceTypeLabel () {
        return this.folder.service_types.map((st) => {
          return st.name
        }).join(', ')
      },
      label () {
        if (this.folder.label) {
          return this.folder.label
        } else {
          return this.serviceTypeLabel
        }
      }
    },
    components: {
      AvatarLogo
    }
  }
</script>

<style lang="stylus">
  .list-account
    &--disabled
      pointer-events: none
</style>



// WEBPACK FOOTER //
// frontend/src/components/list/Account.vue